import { jsx as _jsx } from "react/jsx-runtime";
export const Image = ({ asset, src, alt = '', title, ...rest }) => {
    return (_jsx("img", { src: (asset === null || asset === void 0 ? void 0 : asset.url) ? `https://${asset.url}` : src, alt: (asset === null || asset === void 0 ? void 0 : asset.alt) && alt === '' ? asset === null || asset === void 0 ? void 0 : asset.alt : alt, title: title ? title : asset === null || asset === void 0 ? void 0 : asset.title, ...rest }));
};
